// components/DynamicSelectField.js
import React from "react";
import { useTranslation } from "react-i18next";

const DynamicSelectField = ({
  field,
  value,
  label,
  dynamicOptions = {},
  errors = {},
  isAdviceLoading = false,
  handleSelecChange,
}) => {
  const { t } = useTranslation();

  const getDynamicDropdownOptions = () => {
    const options = dynamicOptions[field] || [];
    if (field === "difficultiesLevel") {
      return options.map((opt) => ({
        value: opt,
        label: opt.charAt(0).toUpperCase() + opt.slice(1),
      }));
    } else {
      return options.map((opt) => ({
        value: opt.id,
        label: opt.name,
      }));
    }
  };

  const options = getDynamicDropdownOptions();

  return (
    <div className="w-full">
      <span className="text-[#414651] text-[12px] font-semibold text-gray-700 uppercase block mb-1">
        {label}
      </span>
      <select
        className={`border p-2 rounded-md w-full h-10 text-sm outline-none bg-white ${
          isAdviceLoading ? "opacity-70 cursor-default" : ""
        }`}
        value={value || ""}
        onChange={(e) => handleSelecChange(field, e.target.value)}
        disabled={isAdviceLoading}
      >
        <option value="" disabled>
          {t("preferences.validation.onlyOne")}
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {errors[field] && (
        <div className="text-red-500 text-[10px] md:text-[12px] ml-2 mt-1">
          {errors[field]}
        </div>
      )}
    </div>
  );
};

export default DynamicSelectField;